import React, { useState } from "react";
import {
  Box,
  Heading,
  Grid,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Button,
  Text,
  useToast,
  Select,
  Flex,
} from "@chakra-ui/react";
import { useAuth } from "../../features/auth/hooks/useAuth";
import { createMission, CreateMissionPayload, MissionStatus } from "../mission/MissionService";
import { useNavigate } from "react-router-dom";

const CreateMissionPage: React.FC = () => {
  const { userInfo, getFullName } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();
  const pink = "#420073";
  const MAX_DESC = 500;

  const [formData, setFormData] = useState({
    opportunite: "",
    description: "",
    status: "EN_COURS" as MissionStatus,
    manager: getFullName(),
    localisation: "",
    experience: "",
  });

  const handleChange = (
      e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    if (name === "description" && value.length > MAX_DESC) return;

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const payload: CreateMissionPayload = {
      commercialId: userInfo.sub,
      ...formData,
      businessDeveloperSub: userInfo.sub,
      managerEmail: userInfo.email,
      manager: getFullName()
    };

    try {
      await createMission(payload);
      toast({
        title: "Mission créée",
        description: "La mission a bien été enregistrée.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      navigate("/historique");
    } catch (error) {
      console.error("Erreur création mission:", error);
      toast({
        title: "Erreur",
        description: "Impossible de créer la mission.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
      <Box bg="gray.50" minH="100vh" p={8}>
        <Box
            maxW="800px"
            mx="auto"
            bg="white"
            p={8}
            borderRadius="xl"
            boxShadow="md"
        >
          <Heading mb={8} fontSize="2xl" color={pink} fontWeight="semibold">
            Nouvelle Mission
          </Heading>

          <form onSubmit={handleSubmit}>
            <Grid templateColumns="repeat(2, 1fr)" gap={6} mb={6}>
              <FormControl>
                <FormLabel fontSize="sm" fontWeight="medium" color="gray.700">
                  Titre
                </FormLabel>
                <Input
                    name="opportunite"
                    value={formData.opportunite}
                    onChange={handleChange}
                    placeholder="Développeur"
                    focusBorderColor={pink}
                />
              </FormControl>

              <FormControl>
                <FormLabel fontSize="sm" fontWeight="medium" color="gray.700">
                  Statut
                </FormLabel>
                <Select
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                    focusBorderColor={pink}
                >
                  <option value="EN_COURS">En cours</option>
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel fontSize="sm" fontWeight="medium" color="gray.700">
                  Localisation
                </FormLabel>
                <Input
                    name="localisation"
                    value={formData.localisation}
                    onChange={handleChange}
                    placeholder="Ville/Pays"
                    focusBorderColor={pink}
                />
              </FormControl>

              <FormControl>
                <FormLabel fontSize="sm" fontWeight="medium" color="gray.700">
                  Expérience requise
                </FormLabel>
                <Input
                    name="experience"
                    value={formData.experience}
                    onChange={handleChange}
                    placeholder="Ex: 3-5 ans"
                    focusBorderColor={pink}
                />
              </FormControl>
            </Grid>

            <FormControl mb={6}>
              <FormLabel fontSize="sm" fontWeight="medium" color="gray.700">
                Description
              </FormLabel>
              <Textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Détails de la mission..."
                  rows={6}
                  focusBorderColor={pink}
                  required
              />
              <Text textAlign="right" mt={2} fontSize="xs" color="gray.500">
                {formData.description.length} / {MAX_DESC} caractères
              </Text>
            </FormControl>

            <Flex justify="flex-end">
              <Button
                  type="submit"
                  bg={pink}
                  color="white"
                  _hover={{ bg: "#6c1fa3" }}
                  px={8}
                  size="md"
              >
                Enregistrer la mission
              </Button>
            </Flex>
          </form>
        </Box>
      </Box>
  );
};

export default CreateMissionPage;